<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Prices</ion-title>
        <ion-buttons slot="end">
            <ion-button data-test="addButton" (click)="onAddPriceClick()">
                <ion-icon name="add"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" class="instructions">
        These prices will be used for two purposes:<br />
        1) To support "Locked In Pricing" the current set of prices will be copied to the AccountProfile.<br />
        2) This table holds the credit cost per message.  For each message sent, this value will be deducted
        from the "Available Credits". 
    </ion-list-header>

    <ion-item-divider color="tertiary">
        <ion-label ion-text-wrap>Active Price Schedule</ion-label>
    </ion-item-divider>

    <ion-list class="ion-padding">
        @for (price of activePrices; track $index) {
  <ion-item-sliding>
            <ion-item [disabled]="vb.disabled" class="ion-text-wrap alternateColor" detail="true"
                    (click)="onPriceClick(price.uid)">
                <ion-label class="ion-text-wrap">
                    <span class="line1">Name: {{price.priceName}}</span><br />
                    <span class="line2">Pay As You Go Base Price: {{price.paygBasePrice | myCurrency}}</span><br />
                    <span class="line2">Pay As You Go Customer Message Credits: {{price.paygCreditsCostPerCustomerMsg}}</span><br />
                    <span class="line2">Pay As You Go Campaign Message Credits: {{price.paygCreditsCostPerCampaignMsg}}</span><br />
                    <span class="line2">Unlimited Monthly Base Price: {{price.unlimitedMonthlyBasePrice | myCurrency}}</span><br />
                    <span class="line2">Unlimited Yearly Base Price: {{price.unlimitedYearlyBasePrice | myCurrency}}</span><br />
                    <span class="line2">Ambassador Yearly Base Price: {{price.ambassadorYearlyBasePrice | myCurrency}}</span><br />
                </ion-label>
            </ion-item>
            <ion-item-options>
                <ion-buttons>
                    <ion-button data-test="deactivateButton" [disabled]="vb.disabled" id="deactivatePrice" color="danger" 
                                (click)="onDeactivatePrice(price)">
                        <ion-icon name="remove-outline"></ion-icon>
                        Deactivate
                    </ion-button>
                </ion-buttons>
            </ion-item-options>
        </ion-item-sliding>
}
    </ion-list>

    <ion-item-divider color="tertiary">
        <ion-label ion-text-wrap>Deactive Price Schedules</ion-label>
    </ion-item-divider>

    <ion-list class="ion-padding">
        @for (price of deactivePrices; track $index) {
  <ion-item-sliding [disabled]="vb.disabled">
            <ion-item [disabled]="vb.disabled" class="ion-text-wrap alternateColor" detail="true"
                    (click)="onPriceClick(price.uid)">
                    <ion-label class="ion-text-wrap">
                        <span class="line1">Name: {{price.priceName}}</span><br />
                        <span class="line2">Pay As You Go Base Price: {{price.paygBasePrice | myCurrency}}</span><br />
                        <span class="line2">Pay As You Go Customer Message Credits: {{price.paygCreditsCostPerCustomerMsg}}</span><br />
                        <span class="line2">Pay As You Go Campaign Message Credits: {{price.paygCreditsCostPerCampaignMsg}}</span><br />
                        <span class="line2">Unlimited Monthly Base Price: {{price.unlimitedMonthlyBasePrice | myCurrency}}</span><br />
                        <span class="line2">Unlimited Yearly Base Price: {{price.unlimitedYearlyBasePrice | myCurrency}}</span><br />
                        <span class="line2">Ambassador Yearly Base Price: {{price.ambassadorYearlyBasePrice | myCurrency}}</span><br />
                    </ion-label>
                </ion-item>
            <ion-item-options>
                <ion-buttons>
                    <ion-button data-test="activateButton" [disabled]="vb.disabled" id="activateprice" color="safe" (click)="onConfirmActivatePrice(price)">
                        <ion-icon name="shield-checkmark-outline"></ion-icon>
                        Activate
                    </ion-button>
                    <ion-button data-test="deleteButton" [disabled]="vb.disabled" id="deletepprice" color="danger" (click)="onConfirmDeletePrice(price)">
                        <ion-icon name="trash"></ion-icon>
                        Delete
                    </ion-button>
                </ion-buttons>
            </ion-item-options>
        </ion-item-sliding>
}
    </ion-list>

</ion-content>
